

import {
  Search,
  SentimentDissatisfied,
  
} from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Products.css";
import ProductCard from "./ProductCard";
import Cart from "./Cart";

// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 *
 * @property {string} name - The name or title of the product
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */

const Products = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [product, setProduct] = useState([]);
  const [search, setSearch] = useState("");
  const [timeoutDebounce, setTimeoutDebounce] = useState(0);
  const [items, setItems] = useState([]);
  const token = localStorage.getItem("token");
  useEffect(() => {
    if (search === "") {
      performAPICall();
    }
    fetchCart(token)
    
  }, []);


  // TODO: CRIO_TASK_MODULE_PRODUCTS - Fetch products data and store it
  /**
   * Make API call to get the products list and store it to display the products
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on all available products
   *
   * API endpoint - "GET /products"
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "name": "iPhone XR",
   *          "category": "Phones",
   *          "cost": 100,
   *          "rating": 4,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "v4sLtEcMpzabRyfx"
   *      },
   *      {
   *          "name": "Basketball",
   *          "category": "Sports",
   *          "cost": 100,
   *          "rating": 5,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "upLK9JbQ4rMhTwt4"
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 500
   * {
   *      "success": false,
   *      "message": "Something went wrong. Check the backend console for more details"
   * }
   */
  const performAPICall = async () => {
    //console.log("i am called");
    console.log("i am performAPICall");
    const URL = config.endpoint + "/products";
    try {
      const response = await axios({
        url: URL,
        method: "get",
      });
      // console.log(response)
      setProduct(response.data);
      // return response.data;
      return response;
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          enqueueSnackbar(error.response.data.message, {
            variant: "error",
          });
        }
      } else {
        enqueueSnackbar(
          "Something went wrong. Check that the backend is running, reachable and returns valid JSON.",
          {
            variant: "error",
          }
        );
      }
      return error;
    }
  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
  /**
   * Definition for search handler
   * This is the function that is called on adding new search keys
   *
   * @param {string} text
   *    Text user types in the search bar. To filter the displayed products based on this text.
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on filtered set of products
   *
   * API endpoint - "GET /products/search?value=<search-query>"
   *
   */
  const performSearch = async (text) => {
    //console.log(text);
    //console.log("haha");
    console.log("i am performing search");
    const URL = config.endpoint + "/products/search?value=" + text;
    try {
      const response = await axios({
        url: URL,
        method: "get",
      });
      // console.log(response)
      setProduct(response.data);
      // return response.data;
      return response;
    } catch (error) {
      if (error.response) {
        if (error.response.status === 404) {
          setProduct([]);
        }
      } else {
        enqueueSnackbar(
          "Something went wrong. Check that the backend is running, reachable and returns valid JSON.",
          {
            variant: "error",
          }
        );
      }
      return error;
    }
  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
  /**
   * Definition for debounce handler
   * With debounce, this is the function to be called whenever the user types text in the searchbar field
   *
   * @param {{ target: { value: string } }} event
   *    JS event object emitted from the search input field
   *
   * @param {NodeJS.Timeout} debounceTimeout
   *    Timer id set for the previous debounce call
   *
   */
  const debounceSearch = (event, debounceTimeout) => {
    console.log("debounce running");

    if (timeoutDebounce !== 0) {
      clearTimeout(timeoutDebounce);
    }
    let timerId = setTimeout(
      () => performSearch(event.target.value),
      debounceTimeout
    );
    setTimeoutDebounce(timerId);
    setSearch(event.target.value);
    //console.log(search);
    //console.log("debounce am running");
  };

  /**
   * Perform the API call to fetch the user's cart and return the response
   *
   * @param {string} token - Authentication token returned on login
   *
   * @returns { Array.<{ productId: string, qty: number }> | null }
   *    The response JSON object
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 401
   * {
   *      "success": false,
   *      "message": "Protected route, Oauth2 Bearer token not found"
   * }
   */
  const fetchCart = async (token) => {
    console.log("i am fetching cart from backend and setItems value...");
    if (!token) return null;
    let url = `${config.endpoint}/cart`;
    try {
      // TODO: CRIO_TASK_MODULE_CART - Pass Bearer token inside "Authorization" header to get data from "GET /cart" API and return the response data
      console.log("i am here");
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      const CartData = response.data
      //console.log("CartData",CartData) 
       
      setItems(CartData)
      return CartData;
    } catch (e) {
      console.log('Cart error',e);
      if (e.response && e.response.status === 400) {
        return enqueueSnackbar(e.response.data.message, { variant: 'error' });
      }
      else {
        enqueueSnackbar("Something went wrong. Check that the backend is running, reachable and returns valid JSON.", { variant: 'error' });
      }
    }
    return null;
  }



// TODO: CRIO_TASK_MODULE_CART - Return if a product already exists in the cart
/**
 * Return if a product already is present in the cart
 *
 * @param { Array.<{ productId: String, quantity: Number }> } items
 *    Array of objects with productId and quantity of products in cart
 * @param { String } productId
 *    Id of a product to be checked
 *
 * @returns { Boolean }
 *    Whether a product of given "productId" exists in the "items" array
 *
 */
const isItemInCart = (items, productId) => {
  console.log("i am checking is item present in cart or not");
  for (let i = 0; i < items.length; i++) {
    if (items[i].productId === productId) {
      if(items[i]._id){
        return false;
      }else{
        return true;
      }
    }
  }
  return false;
};

/**
 * Perform the API call to add or update items in the user's cart and update local cart data to display the latest cart
 *
 * @param {string} token
 *    Authentication token returned on login
 * @param { Array.<{ productId: String, quantity: Number }> } items
 *    Array of objects with productId and quantity of products in cart
 * @param { Array.<Product> } products
 *    Array of objects with complete data on all available products
 * @param {string} productId
 *    ID of the product that is to be added or updated in cart
 * @param {number} qty
 *    How many of the product should be in the cart
 * @param {boolean} options
 *    If this function was triggered from the product card's "Add to Cart" button
 *
 * Example for successful response from backend:
 * HTTP 200 - Updated list of cart items
 * [
 *      {
 *          "productId": "KCRwjF7lN97HnEaY",
 *          "qty": 3
 *      },
 *      {
 *          "productId": "BW0jAAeDJmlZCF8i",
 *          "qty": 1
 *      }
 * ]
 *
 * Example for failed response from backend:
 * HTTP 404 - On invalid productId
 * {
 *      "success": false,
 *      "message": "Product doesn't exist"
 * }
 */
  const addToCart = async (
    token,
    items,
    products,
    productId,
    qty,
    options = { preventDuplicate: false }
  ) => {
    //console.log(items,products,productId,qty);
    console.log("i am adding items to cart if the item is not added previously");
    if (token) {
      if (!isItemInCart(items, productId) ) {
        let postDataToCart = {
          "productId": productId,
          "qty": qty
        }
        let url = `${config.endpoint}/cart`;
        try {
          const response = await axios.post(url, postDataToCart, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          })
          const PostData = response.data

          setItems(PostData);
        }
        catch (e) {
          console.log("i am error for adding element to cart");
          if (e.response && e.response.status === 400) {
            return enqueueSnackbar(e.response.data.message, { variant: 'error' });
          }
          enqueueSnackbar("Item already in cart. Use the cart sidebar to update quantity or remove item.", { variant: 'warning' })
        }
      }
      else {
        enqueueSnackbar("Item already in cart. Use the cart sidebar to update quantity or remove item.", { variant: 'warning' })
      }

    }

    else {
      enqueueSnackbar("Login to add an item to the Cart", { variant: 'warning' })
    }
  };

  return (
    <div>
      <Header>
        {/* TODO: CRIO_TASK_MODULE_PRODUCTS - Display search bar in the header for Products page */}

        <TextField
          className="search-desktop"
          size="small"
          fullWidth
          style={{ margin: "0% 20%" }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search color="primary" />
              </InputAdornment>
            ),
          }}
          placeholder="Search for items/categories"
          name="search"
          value={search}
          onChange={(e) => debounceSearch(e, 500)}
        />
      </Header>

      {/* Search view for mobiles */}
      <TextField
        className="search-mobile"
        size="small"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
        value={search}
        onChange={(e) => debounceSearch(e, 500)}
      />
      {token ?
        <Grid container columns={{ xs: 4, md: 16 }}>
          <Grid item xs={4} md={12}>
            <Grid container>
              <Grid item className="product-grid">
                <Box className="hero">
                  <p className="hero-heading">
                    India’s{" "}
                    <span className="hero-highlight">FASTEST DELIVERY</span> to
                    your door step
                  </p>
                </Box>
              </Grid>
            </Grid>
            {product.length === 0 && search !== "" && (
              <Box className="loading">
                <SentimentDissatisfied />
                <p>No products found</p>
              </Box>
            )}
            {product.length === 0 && search === "" ? (
              <Box className="loading">
                <CircularProgress />
                <p>Loading Products</p>
              </Box>
            ) : (
              <Box className="box-item" sx={{ flexGrow: 1 }}>
                <Grid
                  container
                  spacing={{ xs: 2, md: 3 }}
                  columns={{ xs: 4, md: 16 }}
                >
                  {product.map((item, index) => (
                    <Grid item xs={2} sm={4} md={4} key={index}>

                      <ProductCard product={item} handleAddToCart={() => addToCart(token, items, product, item._id, 1)} />
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}
          </Grid>
          <Grid item xs={4} md={4} style={{ backgroundColor: "#E9F5E1" }}>
            <Cart items={items} products={product} handleQuantity={addToCart} />
          </Grid>
        </Grid>
        :
        <Box>
          <Grid container>
            <Grid item className="product-grid">
              <Box className="hero">
                <p className="hero-heading">
                  India’s{" "}
                  <span className="hero-highlight">FASTEST DELIVERY</span> to
                  your door step
                </p>
              </Box>
            </Grid>
          </Grid>
          {product.length === 0 && search !== "" && (
            <Box className="loading">
              <SentimentDissatisfied />
              <p>No products found</p>
            </Box>
          )}
          {product.length === 0 && search === "" ? (
            <Box className="loading">
              <CircularProgress />
              <p>Loading Products</p>
            </Box>
          ) : (
            
            <Box className="box-item" sx={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, md: 16 }}
              >
                {product.map((item, index) => (
                  <Grid item xs={2} sm={4} md={4} key={index}>
                    <ProductCard product={item} handleAddToCart={() => addToCart(token, items, product, item._id, 1)} />
                  </Grid>
                ))}
              </Grid>

              
            </Box>
            

          )}
        </Box>

      }


      {/* TODO: CRIO_TASK_MODULE_CART - Display the Cart component */}
      <Footer />
    </div>
  )

};

export default Products;



